import styled from 'styled-components';

export const SInput = styled.input<{ error: string; disabled?: boolean; maxWidth?: string }>(
  ({ error, disabled, maxWidth }) => {
    return `
    font-family: 'Poppins';
    height: 40px;
    max-width: ${maxWidth || '100%'};
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 21px;
    border-radius: 8px;
    letter-spacing: normal;
    width: 100%;
    border: 1px solid ${error.length ? '#ED726B' : '#F1F3F5'};
    padding: 9px 8px;
    color: #002169;
    background-color: ${error.length ? 'white' : '#F1F3F5'};
    cursor: ${disabled ? 'no-drop' : 'default'};
    &::placeholder {
      color: #8B939E;
      font-family: 'Poppins';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 21px;
      letter-spacing: 0px;
      text-align: left;
    }
  
    &:focus {
      background-color: white;
    }
    
    `;
  }
);
